import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { path: "/", label: "首页" },
  { path: "/relations", label: "人物关系" },
  { path: "/cp-lines", label: "CP 线" },
  { path: "/daily", label: "师门日常" },
  { path: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-950/95 backdrop-blur"
          : "bg-background-950/70 backdrop-blur-sm"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6 md:py-4">
        <Link to="/" className="flex items-center gap-3 whitespace-nowrap" aria-label="师兄啊师兄人物关系百科 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-xl text-background-50">
            师
          </span>
          <span className="font-[Ma_Shan_Zheng] text-xl text-accent-300 md:text-2xl">师兄啊师兄</span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => {
            const active = pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`whitespace-nowrap text-sm tracking-wide transition-colors ${
                  active
                    ? "text-accent-300"
                    : "text-foreground-100/80 hover:text-accent-200"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            aria-label="打开搜索"
            className="hidden h-10 w-10 items-center justify-center rounded-md text-foreground-100/80 transition-colors hover:bg-background-800/60 hover:text-accent-200 md:flex"
          >
            <i className="ri-search-line text-lg" />
          </button>
          <Link
            to="/relations"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 md:inline-block"
          >
            补课人物关系
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-100/90 hover:bg-background-800/60 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-800 bg-background-950/95 px-4 pb-6 pt-2 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {NAV_ITEMS.map((item) => {
              const active = pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`rounded-md px-3 py-3 text-base ${
                    active
                      ? "bg-background-800/60 text-accent-300"
                      : "text-foreground-100/85 hover:bg-background-800/40"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      )}
    </header>
  );
}